import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.misc.paises.edit}
                postUrl={api.misc.paises.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El País ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar País"}
                buttonTitle={"Editar País"}

                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/misc/Pais/Edit.js